export interface Admin {
    Email?: string;
    First?: string;
    FullName?: string;
    Id?: string;
    id?: string;
    Last?: string;
}

export abstract class AdminExtensions {
    static getAdminKey(a: Admin, defaultKey?: string) { 
        return (a?.Id || a?.id)?.toLowerCase() || defaultKey;
    }
}